export const colors = {
    lightBlue: '#4782da',
    lightGrey: 'rgba(0, 0, 0, 0.15)',
    hoveredButtonGrey: 'rgba(0, 0, 0, 0.04)'
}